var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"color":_vm.selectedColor,"value":_vm.proficiencyPercentage(),"reverse":_vm.selectedLanguage == 'en',"height":"15"}},[_c('strong',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.proficiencyPercentage())+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }